"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp, _dec3, _class3;

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _glamor = require("glamor");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _redial = require("redial");

var _customer = require("redux/modules/customer");

var _gallery = require("redux/modules/gallery");

var _payments = require("redux/modules/payments");

var _subscriptions = require("redux/modules/subscriptions");

var _DescriptionWith3Columns = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/DescriptionWith3Columns");

var _DescriptionWith3Columns2 = _interopRequireDefault(_DescriptionWith3Columns);

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

var _Hero = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Hero");

var _Hero2 = _interopRequireDefault(_Hero);

var _PlanBox = require("@quixeltools/quixel-ui-library/dist/components/quixel/website/PlanBox");

var _PlanBox2 = _interopRequireDefault(_PlanBox);

var _Select = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Select");

var _Select2 = _interopRequireDefault(_Select);

var _Section = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Section");

var _Section2 = _interopRequireDefault(_Section);

var _Tabs = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Tabs");

var _Tabs2 = _interopRequireDefault(_Tabs);

var _HowPointsWork = require("@quixeltools/quixel-ui-library/dist/components/megascans/marketing/HowPointsWork");

var _HowPointsWork2 = _interopRequireDefault(_HowPointsWork);

var _components = require("components");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const cf = path => `https://d3uwib8iif8w1p.cloudfront.net/megascans/${path}`;
var cloudfrontThumbs = function cloudfrontThumbs(path) {
  return "https://cdn.quixel.com/quixel/thumbs/" + path;
};
var cloudfrontIcons = function cloudfrontIcons(path) {
  return "https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/" + path;
};

var plansSection = (0, _glamor.css)({
  paddingTop: "0 !important"
});

var mainDiv = (0, _glamor.css)({
  borderBottom: "1px solid #222"
  // marginTop:'13px',
});

var PLAN_YEARLY = "annual";
var PLAN_MONTHLY = "monthly";

var plansSectionInner = (0, _glamor.css)({
  maxWidth: "87em",
  padding: "0 1.5em !important"
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  padding: "0 2em !important"
}));

var plansWrap = (0, _glamor.css)({
  maxWidth: "83em",
  margin: "auto"
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  padding: 15
}), (0, _css.maxWidth)(_css.breakpoints.medium)({
  width: "80%",
  margin: "auto"
}));

var plansColumns = (0, _glamor.css)((0, _css.minWidth)(_css.breakpoints.medium)({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center"
}));

var plansColumnItem = (0, _glamor.css)({
  margin: "auto",
  marginTop: "1.5em",
  maxWidth: "30em",

  ":first-child": {
    marginTop: 0
  }
}, (0, _css.minWidth)(_css.breakpoints.small)({
  maxWidth: "20em"
}), (0, _css.minWidth)(_css.breakpoints.medium)({
  margin: "initial",
  marginTop: 0,
  flexBasis: "32.66%",
  marginRight: "1%",

  ":nth-child(3)": {
    marginRight: 0
  },

  ":nth-child(4)": {
    marginTop: "1.25em",
    marginRight: 0
  }
}), (0, _css.minWidth)(_css.breakpoints.large)({
  flexBasis: "29.7%",
  marginRight: "1.8%",
  maxWidth: "initial",

  ":nth-child(3)": {
    marginTop: 0,
    marginRight: "0 !important"
  }
}), (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  flexBasis: "31.7%"
}));

var plansDetails = (0, _glamor.css)({
  fontSize: (0, _css.unitRem)(0.75),
  display: "flex",
  flexDirection: "column"
}, (0, _css.minWidth)(_css.breakpoints.large)({
  display: "block"
}));

var plansComparison = (0, _glamor.css)({
  order: 2
}, (0, _css.minWidth)(_css.breakpoints.small)({
  marginTop: "3em"
}), (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  marginTop: "6em"
}));

var plansFooter = (0, _glamor.css)({
  margin: "auto",
  maxWidth: "42em",
  lineHeight: 1.5,
  color: _css.colors.gray,
  textAlign: "left",
  "& span": {
    fontWeight: 300
  }
}, (0, _polyfluid.polyfluid)({
  marginTop: {
    small: [2.6, 3],
    medium: [2, 3]
  },
  marginBottom: {
    small: [5.25, 6],
    medium: [4, 5]
  }
}), (0, _css.maxWidth)(_css.breakpoints.medium)({
  textAlign: "center"
}), (0, _css.minWidth)(_css.breakpoints.small)({
  textAlign: "center"
}), (0, _css.minWidth)(_css.breakpoints.large)((0, _polyfluid.polyfluid)({
  marginTop: {
    small: [6.2, 7.2],
    medium: [6.2, 7.2],
    large: [6.2, 8.6]
  },
  marginBottom: {
    small: [1, 1.125],
    medium: [1, 1.125],
    large: [1.125, 1.5]
  }
})));

var radioLabel = (0, _glamor.css)({
  color: _css.colors.white,
  marginLeft: (0, _css.unitRem)(3),

  "& .text": {
    display: "inline-block",
    verticalAlign: "middle",

    marginLeft: (0, _css.unitRem)(0.5)
  },

  "&:first-child": {
    marginLeft: 0
  }
});

var radio = (0, _glamor.css)({
  display: "inline-block",
  verticalAlign: "middle"
});

var needsChoosing = function needsChoosing(license) {
  return _ramda2.default.compose(_ramda2.default.lt(1), _ramda2.default.length, _ramda2.default.filter(_ramda2.default.propEq("license", license)));
};
var selectWrap = (0, _glamor.css)({
  color: _css.colors.gray,

  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  marginBottom: (0, _css.unitRem)(0.416),
  "& *": {
    textTransform: "capitalize"
  }
});

var selectOptions = (0, _glamor.css)({
  "& *": {
    textTransform: "capitalize"
  }
});

var select = (0, _glamor.css)({
  backgroundColor: "#252525",
  width: "60%",
  minWidth: "12rem",
  ":hover *": {
    cursor: "pointer"
  },
  border: "2px solid #9c9c9c",
  paddingTop: "2px"
}, (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
  display: "none"
}), (0, _css.maxWidth)(_css.breakpoints.small)({
  width: "72%"
}));

var options = [{
  name: "Billed Annually (save 25%)",
  value: 1
}, {
  name: "Billed Monthly",
  value: 2
}];

var tabs = (0, _glamor.css)({}, (0, _css.maxWidth)(_css.breakpoints.mediumSmall)({
  display: "none"
}));
var pointsWorksSection = (0, _glamor.css)({
  fontSize: (0, _css.unitRem)(0.75),
  color: _css.colors.gray,
  fontWeight: 300,
  lineHeight: 1.5,
  textAlign: "center",
  whiteSpace: "pre-line",

  margin: "auto",
  marginTop: (0, _css.unitRem)(1),
  marginBottom: (0, _css.unitRem)(3),

  padding: "0 0"
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  padding: "0 " + (0, _css.unitRem)(0.5)
}), (0, _css.minWidth)(_css.breakpoints.large)({
  padding: "0 " + (0, _css.unitRem)(1.1)
}));
var main = (0, _glamor.css)({
  display: "flex",
  justifyContent: "space-arround",
  maxWidth: "980px",
  margin: "auto"
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  flexDirection: "column"
}));
var col = (0, _glamor.css)({
  flexBasis: "50%"
});
var packsWrap = (0, _glamor.css)({
  maxWidth: _css.sizes.innerMaxWidth,
  margin: "auto"
});
var heading = (0, _glamor.css)({
  textAlign: "left",
  fontWeight: 700
}, (0, _polyfluid.polyfluid)({
  paddingTop: {
    small: 2.5,
    medium: [2, 3.125],
    large: [3.125, 3.5]
  },
  paddingBottom: {
    small: 2.5,
    medium: [2, 2.125],
    large: [2.125, 2.5]
  },
  fontSize: {
    small: 1.8,
    medium: [1.8, 2.225],
    large: [2.125, 2.5]
  }
}));
var subHeading = (0, _glamor.css)({
  color: _css.colors.gray,
  textAlign: "center",
  marginBottom: (0, _css.unitRem)(2),
  fontWeight: 600
}, (0, _polyfluid.polyfluid)({
  marginTop: {
    small: [2],
    medium: [2],
    large: [2, 2]
  },
  fontSize: {
    small: [1],
    medium: [1],
    large: [1.1, 1.1]
  }
}));
var Container = (0, _glamor.css)({
  //display:'flex',
  flexWrap: "wrap",
  width: "100%",
  //maxWidth: '80rem',
  //maxWidth:'1250px',
  margin: "auto",
  // padding:'20px',
  justifyContent: "center",
  boxSizing: "border-box",
  textAlign: "center"
});
var smallHeading = (0, _glamor.css)({
  display: "flex",
  justifyContent: "center",
  textTransform: "uppercase",
  margin: "auto",
  letterSpacing: "0.9px",
  paddingTop: "9.34rem",
  //paddingTop: '9rem',
  marginBottom: "2.125rem",
  fontWeight: "700",
  //color: 'gray',
  textAlign: "center",
  color: _css.colors.gray
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    large: [0.9375, 1.25]
  }
}));
var Heading = (0, _glamor.css)({
  display: "flex",
  justifyContent: "center",
  margin: "auto",
  marginBottom: "5.87rem",
  fontSize: (0, _css.unitRem)(2),
  fontWeight: "700",
  // color: 'white',
  textAlign: "center",
  height: "auto",
  marginTop: "5.87",
  //fontFamily: 'SourceSansPro',
  //fontSize: '48px',
  //fontWeight: 'bold',
  //fontStyle: 'normal',
  fontStretch: "normal",
  lineHeight: "1",
  letterSpacing: "-2.4px",
  //textAlign: 'center',
  color: "#ffffff"
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    small: [2, 2.25],
    medium: [2.25, 2.5],
    large: [2.5, 3.75]
  }
}));
var hr = (0, _glamor.css)({
  width: "10rem",
  marginTop: "5.87rem",
  display: "block",
  marginBottom: (0, _css.unitRem)(4),
  border: "none",
  height: "2px",
  backgroundBlendMode: "normal, color",
  backgroundImage: "linear-gradient(-90deg,#2b98f0, #6497bf)"
});
var cloudfront = function cloudfront(path) {
  return "https://d3uwib8iif8w1p.cloudfront.net/megascans/home/" + path;
};
// const clients = [
//   cloudfront('client_logos/Unity.png'),
//   cloudfront('client_logos/Avalanche.png'),
//   cloudfront('client_logos/ilp.png'),
//   cloudfront('client_logos/Dambuster.png'),
//   cloudfront('client_logos/Outsiders.png'),
//   '/icons/clients/double_negative.png',
//   cloudfront('client_logos/Capcom.png'),
//   cloudfront('client_logos/Bungie.png'),
// ];

var faqs = [{
  question: "What does Quixel Cloud include?",
  answer: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem."
}, {
  question: "What does Megascans Points do?",
  answer: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem."
}, {
  question: "What is Suite2?",
  answer: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem."
}, {
  question: "How photoshop plugin works?",
  answer: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem."
}, {
  question: "What is Bridge?",
  answer: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem."
}];
var plugins = [{
  image: "http://d3uwib8iif8w1p.cloudfront.net/megascans/misc/indie.jpg",
  name: "Indie Program",
  description: "Are you a small indie team that need our tools but don’t have the budget? Apply for our Indie Program and get the tools for free, and pay 2.5% when you succeed.",
  icon: "http://d3uwib8iif8w1p.cloudfront.net/megascans/icons/IndieQuixel.png"
}, {
  image: "http://d3uwib8iif8w1p.cloudfront.net/megascans/misc/education.jpg",
  name: "Educational Program",
  description: "Are you a teacher or school? Contact us for free access to all our tools for yourself and your students. This licence is for non-commercial purposes only.",
  icon: ""
}];
var containerDiv = (0, _glamor.css)({
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "4rem",
  width: "100%",
  marginLeft: "7.5rem",
  margin: "auto"
}, (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
  display: "flex",
  justifyContent: "space-between",
  margin: "auto"
}), (0, _css.maxWidth)(_css.breakpoints.large)({
  justifyContent: "space-between"
}), (0, _css.maxWidth)(_css.breakpoints.medium)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  margin: "auto"
}));
var innerContainer = (0, _glamor.css)({
  display: "flex",
  flexDirection: "column",
  marginBottom: "1rem",
  textAlign: "left",
  letterSpacing: "0.6px"
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  display: "flex",
  justifyContent: "center",
  margin: "auto"
}));

var descDiv = (0, _glamor.css)({
  color: _css.colors.gray,
  marginBottom: "1rem",
  letterSpacing: "-0.6px",
  lineHeight: "normal",
  width: "20rem"
}, (0, _css.maxWidth)(_css.breakpoints.xlarge)({
  width: "17rem"
}), (0, _polyfluid.polyfluid)({
  fontSize: {
    small: 1.125,
    medium: 1.125,
    large: [1.125, 1.5]
  }
}));
var Info = (0, _glamor.css)({
  // marginTop: '4rem',
  //marginBottom:'4rem',
  textAlign: "left",
  color: _css.colors.gray,
  marginRight: "1rem",
  paddingBottom: "9rem",
  width: "100%"
}, (0, _css.maxWidth)(_css.breakpoints.large)({
  //paddingLeft: '4.8rem',
  // paddingRight: '4rem'
}), (0, _css.maxWidth)(_css.breakpoints.medium)({
  textAlign: "center",
  paddingLeft: "2rem",
  paddingRight: "2rem"
}), (0, _polyfluid.polyfluid)({
  fontSize: {
    small: 1.125,
    medium: 1.125,
    large: [1.125, 1.5]
  }
}));

var _faq = (0, _glamor.css)({
  maxWidth: _css.sizes.innerMaxWidth - 100,
  marginBottom: (0, _css.unitRem)(2),
  margin: "auto"
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  width: "80%",
  margin: "auto"
}), (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  marginLeft: (0, _css.unitRem)(2),
  marginRight: (0, _css.unitRem)(2),
  marginBottom: (0, _css.unitRem)(4)
}), (0, _css.minWidth)(_css.breakpoints.xlarge)({
  margin: "auto"
}));
var _subHeading = (0, _glamor.css)({
  height: "27px",
  fontSize: "1.4rem",
  fontWeight: "700",
  marginBottom: (0, _css.unitRem)(1.3),
  textAlign: "left",
  color: "#ffffff",
  letterSpacing: "-0.0937rem"
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    small: 1.5,
    medium: 1.275,
    large: [1.5, 2]
  }
}));

var Education = (_dec = (0, _redial.provideHooks)({
  fetch: function fetch(_ref) {
    var dispatch = _ref.store.dispatch;

    var plans = dispatch((0, _subscriptions.getSubscriptionPlans)());
    var upgradeParams = dispatch((0, _payments.getUpgradeParams)());
    return _bluebird2.default.all([plans, upgradeParams]).then(function (e) {}, function (e) {
      console.log(e);
    });
  },
  defer: function defer(_ref2) {
    var dispatch = _ref2.store.dispatch;

    var plans = dispatch((0, _subscriptions.getSubscriptionPlans)());
    var upgradeParams = dispatch((0, _payments.getUpgradeParams)());
    var customerInfo = dispatch((0, _customer.getCustomer)());
    var gallery = dispatch((0, _gallery.getGalleryData)());
    return _bluebird2.default.all([plans, upgradeParams, customerInfo, gallery]).then(function (e) {}, function (e) {
      console.log(e);
    });
  }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    subscription: state.user && state.user.subscription,
    plans: state.subscriptions.plans,
    plansDecorated: state.subscriptions.plansDecorated,
    plansDecoratedAnual: state.subscriptions.plansDecoratedAnual,
    educationalPlan: state.subscriptions.educationalPlan,
    customer: state.customer && state.customer.customer,
    galleryData: state.gallery.data,
    loading: state.gallery.loading,
    loaded: state.gallery.loaded,
    loggedIn: state.auth.loggedIn,
    user: state.user
  };
}, { initPayment: _payments.initPayment }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Education, _React$Component);

  function Education(props) {
    (0, _classCallCheck3.default)(this, Education);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Education.__proto__ || (0, _getPrototypeOf2.default)(Education)).call(this, props));

    _this.renderHeader = function () {
      return _react2.default.createElement(_Hero2.default, {
        bg: "/images/education/edu-hero-min.png",
        title: "Unleash cutting edge creativity <br> in your classroom today",
        subTitle: "",
        primaryLabel: "",
        primaryTo: "",
        secondaryLabel: "ENROLL FREE",
        secondaryTo: "",
        onClickSecondaryHandler: function onClickSecondaryHandler() {
          _this.renderContactUsForm();
        },
        linkIcon: "rightSide",
        link: {
          label: "Learn more",
          href: _config2.default.forumBaseUrl,
          target: "_blank",
          rel: "noreferrer"
        },
        onClickHandler: _this.handleClick
      });
    };

    _this.onClickHandler = function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.props.loggedIn) {
        this.context.dialogs.custom(_react2.default.createElement(_components.EducationProgramContainer, {
          title: "Looking to join the Indie Program?",
          description: "Leave us a note and we will get back to you soon.",
          tag: "education-program",
          initialValues: {
            name: "",
            email: this.props.user.email,
            url: "",
            subject: "Educational Program Application",
            indieMessage: ""
          }
        }));
      } else {
        _reactRouter.browserHistory.push({
          pathname: "/login",
          search: "?returnTo=/education#contactUs"
        });
      }
    };

    _this.yearlyMonthlyToggle = function (plans) {
      return _react2.default.createElement(
        "div",
        {
          style: {
            maxWidth: "640px",
            textAlign: "center",
            margin: "auto",
            marginTop: 38
          } },
        _react2.default.createElement(
          "div",
          { className: tabs },
          _react2.default.createElement(
            _Tabs2.default,
            {
              active: _this.state.subscriptionType == PLAN_YEARLY ? 0 : 1,
              onSetActiveTab: function onSetActiveTab(tab) {
                _this.setState({
                  subscriptionType: tab == 0 ? PLAN_YEARLY : PLAN_MONTHLY
                });
              },
              styles: { background: "rgba(95,95,95,0.7)" } },
            _react2.default.createElement(_Tabs.Tab, { label: "Billed Annually (save 25%)" }),
            _react2.default.createElement(_Tabs.Tab, { label: "Billed Monthly" })
          )
        ),
        _react2.default.createElement(_Select2.default, {
          thin: true,
          mode: "white",
          className: select,
          options: options,
          onChange: _this.onChange,
          value: options[_this.state.subscriptionType == PLAN_YEARLY ? 0 : 1].value
        })
      );
    };

    _this.renderPlansComparison = function (plans) {
      return _react2.default.createElement(
        "div",
        { className: Container },
        _react2.default.createElement(_DescriptionWith3Columns2.default, {
          title: "MEGASCANS EDUCATIONAL PROGRAM",
          headingBeforeBreak: "Build exciting new worlds with",
          headingAfterBreak: "Quixel\u2019s industry-leading creative apps.",
          columns: [{
            img: cloudfrontIcons("megascans_icon_2048_preview.png"),
            isIcon: true,
            title: "Megascans",
            desc: "Megascans assets for Education contain hundreds of high-resolution PBR-calibrated surface, vegetation and 3D materials. ",
            alignLeft: true
          }, {
            img: cloudfrontIcons("bridge_icon_2048.png"),
            isIcon: true,
            title: "Bridge",
            desc: "Bridge connects Megascans to all your favorite tools. Browse, manage, and export assets, straight from your desktop.",
            alignLeft: true
          }, {
            img: cloudfrontIcons("mixer_icon_2048_preview.png"),
            isIcon: true,
            title: "Mixer",
            desc: "Simple and easy material creation. Create photorealistic, tileable, materials in seconds with powerful mixing and painting.",
            alignLeft: true
          }]
        })
      );
    };

    _this.renderPlans = function (plansDecorated, plans) {
      var _this$props = _this.props,
          subscription = _this$props.subscription,
          initPayment = _this$props.initPayment,
          educationalPlan = _this$props.educationalPlan;

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: plansWrap },
          _react2.default.createElement(
            "div",
            { className: plansColumns },
            educationalPlan.map(function (plan) {
              var selectTo = _ramda2.default.ifElse(needsChoosing(plan.license), _ramda2.default.always("/choose/" + plan.planType), _ramda2.default.always("/subscribe/" + plan.type))(plans);
              var isSamePlan = subscription && plan.name === subscription.planName;
              var isSameBillingn = subscription && plan.billing === subscription.billing;
              var canUpgrade = subscription && subscription.isActive && subscription.doesGetCharged;
              return _react2.default.createElement(
                "div",
                { className: plansColumnItem, key: plan.license },
                _react2.default.createElement(_PlanBox2.default, (0, _extends3.default)({
                  onUpgradeSubscriptionClick: function onUpgradeSubscriptionClick() {
                    _this.onUpgradeSubscriptionClick(subscription);
                  },
                  contactUsDescription: plan.constactUsDesc ? plan.constactUsDesc : false,
                  planType: "EDUCATIONAL PROGRAM",
                  name: plan.name,
                  logo: "https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/megascans_icon_2048_preview.png",
                  desc: plan.desc,
                  subDesc: plan.subDesc,
                  // barColor: 'blue',
                  buttonColor: "blue",
                  educational: true,
                  buttonSubscribeLabel: "Enroll",
                  buttonLearnMoreLabel: plan.name === "Education XL" ? "LEARN MORE" : "ENROLL FREE",
                  buttonContactUsLearnMoreLabel: plan.name === "Education XL" ? "LEARN MORE" : "ENROLL FREE",
                  isCurrentPlan: subscription && subscription.isActive && (isSamePlan && isSameBillingn || plan.license === "custom" && !subscription.doesGetCharged),
                  learnMoreHref: "",

                  price: plan.billing == "annual" && plan.name !== "Business" ? plan.amount / 12 : plan.amount,
                  pointsPerMonth: plan.billing == PLAN_MONTHLY ? plan.points : null,
                  pointsPerYear: plan.billing == PLAN_YEARLY ? plan.points : null,
                  cycle: plan.billing,
                  upgrade: subscription && canUpgrade && isSamePlan && !isSameBillingn && subscription.billing == PLAN_MONTHLY,
                  subscribed: !!subscription,
                  selectTo: plan.subscribeHandleClick ? "" : selectTo,
                  marketingPoints: plan.marketingPoints,

                  initializePayment: function initializePayment() {
                    // initPayment(plan, this.state.subscriptionType)
                    if (plan.subscribeHandleClick) {
                      _this.renderContactUsForm();
                    }
                  },
                  contactUs: (!isSamePlan || !isSameBillingn) && (plan.contactUs || subscription && subscription.isActive),
                  hidePrice: plan.contactUs
                }, plan.contactUs && {
                  handleClick: function handleClick() {
                    _this.renderContactUsForm();
                  }
                }, !plan.contactUs && subscription && {
                  handleClick: function handleClick() {
                    _this.renderContactUsForm();
                  }
                }))
              );
            })
          )
        )
      );
    };

    _this.renderHowPointsWork = function () {
      return _react2.default.createElement(_HowPointsWork2.default, {
        assetTypes: [{
          title: "3D Models",
          imgSrc: "/images/pricing/points-3d.png",
          points: "3-12"
        }, {
          title: "Vegetation",
          imgSrc: "/images/pricing/points-vegetation.png",
          points: "1-2"
        }, {
          title: "Surfaces",
          imgSrc: "/images/pricing/points-surfaces.png",
          points: "1-4"
        }],
        detailPoints: [{
          title: "Yours Forever",
          description: "Use your downloaded assets for free, as long as you're on an active subscription."
        }, {
          title: "Re-download for Free",
          description: "Re-download assets you’ve already bought free of charge at any time."
        }, {
          title: "Add Points Anytime",
          description: "Add more points to your subscription at any time from within your account."
        }]
      });
    };

    _this.renderContent = function (plansDecorated, plans) {
      var galleryData = _this.props.galleryData && _this.props.galleryData.length && _this.props.galleryData.slice(0, 12);
      return _react2.default.createElement(
        "div",
        { className: mainDiv },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "div",
            { className: (0, _glamor.css)({ background: _css.colors.darkGray }) },
            _react2.default.createElement(
              "h4",
              { className: smallHeading },
              "Made with Quixel"
            ),
            _react2.default.createElement(
              "h1",
              { className: Heading },
              "Get inspired!",
              _react2.default.createElement("br", null),
              "Create anything you can imagine."
            ),
            _react2.default.createElement("hr", {
              className: (0, _glamor.css)({
                width: "10rem",
                height: "2px",
                borderColor: "#2b98f0",
                marginBottom: "6rem",
                display: "block",
                border: "none",
                backgroundBlendMode: "normal, color",
                backgroundImage: "linear-gradient(-90deg,#2b98f0, #6497bf)"
              }) }),
            _react2.default.createElement(Grid, {
              galleryData: galleryData,
              loaded: _this.props.loaded,
              currentCategory: _this.state.currentCategory
            })
          ),
          _react2.default.createElement(_DescriptionWith3Columns2.default, {
            title: "MADE FOR SCHOOLS",
            headingBeforeBreak: "Cutting-edge creativity today. ",
            headingAfterBreak: "A competitive edge tomorrow.",
            columns: [{
              img: "",
              isIcon: false,
              title: "Flexible licensing.",
              desc: "Made for classrooms of all sizes. Deploy to your entire network or to personal devices."
            }, {
              img: "",
              isIcon: false,
              title: "Get live app updates.",
              desc: "Tune into the latest tech.<br/><br/>You\u2019ll always be on the most current versions of Quixel\u2019s apps, including public betas."
            }, {
              img: "",
              isIcon: false,
              title: "Works with your tools.",
              desc: "Megascans assets are stardardized to work in all your favorite tools, and our apps integrate with all major real-time engines, modeling apps, and renderers."
            }]
          })
        ),
        _react2.default.createElement(_Hero2.default, {
          hrLine: true,
          bg: "/images/education/edu-bottom-cta-min.png",
          title: "Join the Educational Program, Free!",
          subTitle: "Give your students the power to create bright futures. Apply now to get access to our amazing set of tools.",
          linkIcon: "rightSide",
          secondaryLabel: "ENROLL FREE",
          secondaryTo: "",
          onClickSecondaryHandler: function onClickSecondaryHandler() {
            _this.renderContactUsForm();
          },
          link: {
            label: "Learn the details",
            to: _config2.default.forumBaseUrl,
            target: "_blank",
            rel: "noreferrer"
          }
        })
      );
    };

    _this.onUpgradeSubscriptionClick = _this.onUpgradeSubscriptionClick.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.onClickHandler = _this.onClickHandler.bind(_this);
    _this.state = {
      subscriptionType: props.subscription ? props.subscription.billing : PLAN_YEARLY,
      isOpened: false
    };
    return _this;
  }

  (0, _createClass3.default)(Education, [{
    key: "onChange",
    value: function onChange(e) {
      e.preventDefault();
      var value = e.target.value - 1;
      this.setState({
        subscriptionType: value == 0 ? PLAN_YEARLY : PLAN_MONTHLY
      });
    }
  }, {
    key: "renderContactUsForm",
    value: function renderContactUsForm() {
      window.open(_config2.default.forumBaseUrl, "_blank");
    }
  }, {
    key: "onUpgradeSubscriptionClick",
    value: function onUpgradeSubscriptionClick(subscription) {
      var dialogs = this.context.dialogs;

      var props = this.props;
      if (_payments.upgradeablePlanIds.indexOf(subscription.planId) === -1) {
        dialogs.custom(_react2.default.createElement(_components.ContactUsPopupContainer, {
          title: "Looking for a change in plan?",
          description: "Leave us a note and we will get back to you soon.",
          tag: "megascans-subscription-monthlyToAnnual-switch-request",
          initialValues: {
            name: _ramda2.default.propOr("", "name", props.customer),
            email: _ramda2.default.propOr("", "user", props.customer),
            subject: _ramda2.default.propOr("Request for switching monthly subscription to Annual Plan", "subject", subscription),
            comment: _ramda2.default.propOr("", "comment", subscription)
          }
        }));
      } else {
        dialogs.custom(_react2.default.createElement(_components.UpgradeSubscriptionPopup, null));
      }
    }
  }, {
    key: "renderSubSections",
    value: function renderSubSections() {
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: main },
          _react2.default.createElement(
            "div",
            { className: col },
            _react2.default.createElement(
              "div",
              {
                className: (0, _glamor.css)({
                  maxWidth: _css.sizes.innerMaxWidthTight,
                  margin: (0, _css.unitRem)(1.1) + " auto"
                }) },
              _react2.default.createElement(
                "h1",
                {
                  className: (0, _glamor.css)({
                    fontSize: (0, _css.unitRem)(1.25),
                    fontWeight: 300,
                    lineHeight: 1.5,
                    textAlign: "center"
                  }, (0, _css.maxWidth)(_css.breakpoints.medium)({
                    fontSize: (0, _css.unitRem)(1)
                  })) },
                "Add Points Anytime"
              ),
              _react2.default.createElement(
                "p",
                { className: pointsWorksSection },
                "Add more points to your subscription at any time from within your account."
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: col },
            _react2.default.createElement(
              "div",
              {
                className: (0, _glamor.css)({
                  maxWidth: _css.sizes.innerMaxWidthTight,
                  margin: (0, _css.unitRem)(1.1) + " auto"
                }) },
              _react2.default.createElement(
                "h1",
                {
                  className: (0, _glamor.css)({
                    fontSize: (0, _css.unitRem)(1.25),
                    fontWeight: 300,
                    lineHeight: 1.5,
                    textAlign: "center"
                  }, (0, _css.maxWidth)(_css.breakpoints.medium)({
                    fontSize: (0, _css.unitRem)(1)
                  })) },
                "Yours Forever"
              ),
              _react2.default.createElement(
                "p",
                { className: pointsWorksSection },
                "Use your downloaded assets for free, as long as you're on an active subscription."
              )
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: main },
          _react2.default.createElement(
            "div",
            { className: col },
            _react2.default.createElement(
              "div",
              {
                className: (0, _glamor.css)({
                  maxWidth: _css.sizes.innerMaxWidthTight,
                  margin: (0, _css.unitRem)(1.1) + " auto"
                }) },
              _react2.default.createElement(
                "h1",
                {
                  className: (0, _glamor.css)({
                    fontSize: (0, _css.unitRem)(1.25),
                    fontWeight: 300,
                    lineHeight: 1.5,
                    textAlign: "center"
                  }, (0, _css.maxWidth)(_css.breakpoints.medium)({
                    fontSize: (0, _css.unitRem)(1)
                  })) },
                "Re-download Assets for Free"
              ),
              _react2.default.createElement(
                "p",
                { className: pointsWorksSection },
                "Re-download assets that you have already bought, free of charge at any time."
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: col },
            _react2.default.createElement(
              "div",
              {
                className: (0, _glamor.css)({
                  maxWidth: _css.sizes.innerMaxWidthTight,
                  margin: (0, _css.unitRem)(1.1) + " auto"
                }) },
              _react2.default.createElement(
                "h1",
                {
                  className: (0, _glamor.css)({
                    fontSize: (0, _css.unitRem)(1.25),
                    fontWeight: 300,
                    lineHeight: 1.5,
                    textAlign: "center"
                  }, (0, _css.maxWidth)(_css.breakpoints.medium)({
                    fontSize: (0, _css.unitRem)(1)
                  })) },
                "Points are Carried Over"
              ),
              _react2.default.createElement(
                "p",
                { className: pointsWorksSection },
                "Left over points from each month / year get carried over to the next."
              )
            )
          )
        )
      );
    }
  }, {
    key: "renderPointsWorksSection",
    value: function renderPointsWorksSection() {
      return _react2.default.createElement(_Section2.default, {
        headerClassName: (0, _glamor.css)({ marginBottom: (0, _css.unitRem)(2) }),
        title: "How do points work?",
        hr: true,
        subTitle: _react2.default.createElement(
          "span",
          { className: (0, _glamor.css)({ fontSize: (0, _css.unitRem)(0.75) }) },
          "Your subscription comes with a set number of points that you can use to download content. Your points get refilled monthly / annually depending on your subscription and all unused points stay in your wallet forever."
        ),
        content: this.renderSubSections()
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          plans = _props.plans,
          plansDecorated = _props.plansDecorated,
          location = _props.location,
          loggedIn = _props.loggedIn;


      var hash = location.hash;
      if (hash && hash.length) {
        if (hash.indexOf("#") == 0) {
          hash = hash.slice(1);
        }
        if (hash === "contactUs" && !this.state.isOpened) {
          this.renderContactUsForm();
        }
      }

      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "- Bring Megascans to your classroom",
          documentImage: cloudfrontThumbs("page-thumb-education.jpg"),
          documentDescription: "Quixel Megascans is the leader in premium quality 3D asset scans for film VFX, game development and visualization. Join the educational program, free!" },
        _react2.default.createElement(
          "div",
          null,
          this.renderHeader(),
          _react2.default.createElement(
            "div",
            { className: plansDetails },
            this.renderPlansComparison(plansDecorated)
          ),
          this.renderContent(plansDecorated, plans)
        )
      );
    }
  }]);
  return Education;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = Education;


var windowWidth = void 0;

var loadingSpinnerStyles = (0, _glamor.css)({
  textAlign: "center",
  padding: "50px"
});

var galleryStyles = (0, _glamor.css)({
  position: "relative",
  transform: "translateZ(0)"
});

var tileStyles = (0, _glamor.css)({
  height: "100%",

  float: "left",
  position: "absolute",
  cursor: "pointer",
  transition: "transform 0.4s",
  transform: "translateZ(0)",
  display: "table",
  background: "#000",
  "& > img": {
    maxHeight: "100%",
    height: "100%",
    width: "100%",
    transition: "all 0.2s ease-out",
    background: "#000"
  },
  "&:hover": {
    zIndex: 1,
    "& > img": {
      transform: "scale(1.05, 1.05)"
    },
    "& > div": {
      transform: "scale(1.05, 1.05)",
      opacity: "1"
    }
  }
});

var imageDescStyles = function imageDescStyles(fontScale) {
  return (0, _glamor.css)({
    opacity: "0",
    color: "#fff",
    position: "absolute",
    top: "0px",
    left: "0px",
    padding: "1.2vw",
    background: "rgba(0,0,0,0.5)",
    width: "100%",
    height: "100%",
    transition: "all 0.2s ease-out",

    "& > div:nth-child(1)": {
      fontSize: (0, _css.unitRem)(0.6 * fontScale),
      whiteSpace: "nowrap",
      overflow: "hidden",
      paddingBottom: "5px",
      textOverflow: "ellipsis"
    },
    "& > div:nth-child(2)": {
      fontSize: (0, _css.unitRem)(0.45 * fontScale),
      color: "#ccc"
    },
    "& > div:nth-child(3)": {
      padding: "15px 0px",
      fontSize: "12px",
      color: "#bbb",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      textTransform: "uppercase"
    }
  });
};

var messageBelowStyles = (0, _glamor.css)({
  textAlign: "center",
  padding: "5.8em",
  background: "#121212",
  "& > h1": {
    paddingBottom: "0.85em"
  },
  "& > span": {
    lineHeight: "1.5em"
  },
  "& > a": {
    fontSize: "1.125em"
  }
});

var sendUs = (0, _glamor.css)({
  display: "flex",
  justifyContent: "center",
  margin: "auto",
  letterSpacing: "-0.6px",
  fontSize: "1.3rem",
  //marginTop: '9.34rem',
  //paddingTop: '9rem',
  marginBottom: "2.8rem",
  fontWeight: "300",
  //color: 'gray',
  textAlign: "center",
  maxWidth: "630px",
  color: "#6f6f6f"
}, (0, _css.maxWidth)(_css.breakpoints.large)({
  display: "flex",
  justifyContent: "center"
}));

var linkWrap = (0, _glamor.css)({
  height: "100%",
  float: "left",
  position: "absolute",
  display: "table",
  background: "#000"
});

var toolsIcons = (0, _glamor.css)({
  marginTop: "1.5em"
});
var toolText = function toolText(fontScale) {
  return (0, _glamor.css)({
    color: "#aaa",
    fontSize: (0, _css.unitRem)(0.45 * fontScale),
    marginTop: "2px",
    top: "-5px",
    position: "relative",
    display: "inline",
    whiteSpace: "nowrap"
  });
};

var toolIcon = (0, _glamor.css)({
  marginLeft: "0.5em",
  position: "relative",
  display: "inline",
  "&:first-child": {
    marginLeft: 0
  },
  "& img": {
    width: 20,
    height: 20
  },
  "&:hover": {
    "& span": {
      display: "block"
    }
  }
});

var toolName = (0, _glamor.css)({
  display: "none",
  position: "absolute",
  borderRadius: "3px",
  top: "-20px",
  fontSize: "13px",
  background: "rgba(0,0,0,0.5)",
  color: "#aaa",
  left: "50%",
  transform: "translateX(-50%)",
  whiteSpace: "nowrap",
  textTransform: "capitalize",
  padding: "0px 4px 1px"
});

var _cloudfront = function _cloudfront(path) {
  return "https://d3uwib8iif8w1p.cloudfront.net/quixel/" + path;
};

var Grid = (_dec3 = (0, _reactRedux.connect)(function (state) {
  return {
    loggedIn: state.auth.loggedIn
  };
}), _dec3(_class3 = function (_React$Component2) {
  (0, _inherits3.default)(Grid, _React$Component2);

  function Grid() {
    (0, _classCallCheck3.default)(this, Grid);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (Grid.__proto__ || (0, _getPrototypeOf2.default)(Grid)).call(this));

    _this2.onWindowResize = _this2.onWindowResize.bind(_this2);
    _this2.issizing = false;
    return _this2;
  }

  (0, _createClass3.default)(Grid, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (!__SERVER__) {
        window.addEventListener("resize", this.onWindowResize);
        windowWidth = window.innerWidth;
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.loaded == false && nextProps.loaded == true || this.props.currentCategory != nextProps.currentCategory) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.onWindowResize);
    }
  }, {
    key: "onWindowResize",
    value: function onWindowResize() {
      var _this3 = this;

      if (!this.issizing) {
        this.issizing = true;
        setTimeout(function () {
          windowWidth = window.innerWidth;
          _this3.forceUpdate();
          _this3.issizing = false;
        }, 200);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      if (!this.props.loaded) {
        return _react2.default.createElement(
          "div",
          { className: loadingSpinnerStyles },
          _react2.default.createElement(_Preloader2.default, null)
        );
      }
      var imagesToLoad = 0;
      var imageIndex = 0;
      var loadImage = function loadImage() {
        var tile = _this4["refImage_" + imageIndex];
        if (tile) {
          imageIndex++;
          imagesToLoad++;
          var img = tile.refImage;
          img.onload = function () {
            this.onload = null;
            this.onerror = null;
            imagesToLoad--;
            loadImage();
          };
          img.onerror = function () {
            this.onload = null;
            this.onerror = null;
            imagesToLoad--;
            loadImage();
          };
          img.src = tile.props.data.img.src;
          if (imagesToLoad < 5) {
            loadImage();
          }
        }
      };

      setTimeout(function () {
        loadImage();
      }, 5);

      var positionData = getTilesPositionData(this.props.galleryData, this.props.currentCategory);
      var imagePositionData = positionData.imageData;
      var fontScale = positionData.fontScale;
      var galleryHeight = positionData.galleryHeight;
      var galleryStyle = {
        height: galleryHeight + "px"
      };
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { id: "grid", key: "grid", className: galleryStyles, style: galleryStyle },
          imagePositionData.map(function (imageData, index) {
            imageData.img.index = index;
            return _react2.default.createElement(Tile, {
              key: index,
              ref: function ref(tile) {
                _this4["refImage_" + index] = tile;
              },
              data: imageData,
              fontScale: fontScale,
              totalImages: 6
            });
          })
        ),
        _react2.default.createElement(
          "div",
          {
            className: (0, _glamor.css)({ display: "flex", justifyContent: "center", padding: (0, _css.unitRem)(2) }, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
              flexDirection: "column",
              textAlign: "center"
            })) },
          _react2.default.createElement(_components.TextButtonLibrary, { label: "VIEW ARTIST GALLERY", mode: "small", className: _reactRouter.Link, to: "/gallery" })
        )
      );
    }
  }]);
  return Grid;
}(_react2.default.Component)) || _class3);

var getTilesPositionData = function getTilesPositionData(galleryData, currentCategory) {
  var defaultRowHeight = Math.floor(windowWidth / 5.7);
  if (defaultRowHeight < 200) {
    defaultRowHeight = 200;
  }

  var rowWidth = 0;
  var rowWidths = [];
  var rows = [];
  var scaledWidth = void 0;
  var row = [];
  var img = void 0;
  // galleryData = PHOTO_SET;
  for (var i = 0; i < galleryData.length; i++) {
    img = galleryData[i];
    // if (currentCategory !== 'everything' && currentCategory !== img.category) {
    //   row.push(img);
    //   continue;
    // }

    scaledWidth = img.width * (defaultRowHeight / img.height) + 3;

    if (rowWidth + scaledWidth / 2 > windowWidth) {
      rows.push(row);
      row = [];
      rowWidths.push(rowWidth);
      rowWidth = 0;
    }

    row.push(img);
    rowWidth += scaledWidth;
  }
  if (row.length > 1) {
    rowWidths.push(rowWidth);
    rows.push(row);
  }

  var rowHeights = [];
  var imageData = [];
  var rowHeight = void 0;
  var ratio = void 0;
  var topPos = 0;
  var leftPos = 0;
  var tileWidth = void 0;
  var galleryHeight = 0;
  var imgData = void 0;

  for (var _i = 0; _i < rows.length; _i++) {
    rowHeight = defaultRowHeight;
    if (rowWidths[_i] !== windowWidth) {
      ratio = rowWidths[_i] / windowWidth;
      rowHeight = defaultRowHeight / ratio;
    }

    for (var j = 0; j < rows[_i].length; j++) {
      img = rows[_i][j];
      ratio = rowHeight / img.height;
      tileWidth = img.width * ratio;
      imgData = {
        img: img,
        imageHeight: rowHeight,
        imageWidth: tileWidth,
        topPos: topPos,
        leftPos: leftPos,
        visibility: "1",
        scale: ratio
      };
      // if (currentCategory !== 'everything' && currentCategory !== img.category) {
      //   //imgData.visibility = '0';
      // } else {
      leftPos += tileWidth + 4;
      //}
      imageData.push(imgData);
    }
    leftPos = 0;
    topPos += rowHeight + 4;
  }
  if (defaultRowHeight < 300) {
    // defaultRowHeight = 300;
  }
  var fontScale = 1 + (defaultRowHeight - 252) / 300;
  // if(fontScale < 0.7 )fontScale = 0.7;
  return {
    imageData: imageData,
    galleryHeight: topPos,
    fontScale: fontScale
  };
};

var Tile = function (_React$Component3) {
  (0, _inherits3.default)(Tile, _React$Component3);

  function Tile(props) {
    (0, _classCallCheck3.default)(this, Tile);

    var _this5 = (0, _possibleConstructorReturn3.default)(this, (Tile.__proto__ || (0, _getPrototypeOf2.default)(Tile)).call(this, props));

    _this5.getPreviousItem = _this5.getPreviousItem.bind(_this5);
    _this5.getNextItem = _this5.getNextItem.bind(_this5);
    return _this5;
  }

  (0, _createClass3.default)(Tile, [{
    key: "getPreviousItem",
    value: function getPreviousItem(itemId) {
      var _this6 = this;

      var imgIndex = parseInt(itemId, 10) - 1;

      return imgIndex < 0 ? null : {
        pathname: "/gallery/" + imgIndex,
        state: {
          modal: true,
          fullScreen: true,

          previousTo: function previousTo() {
            return _this6.getPreviousItem(imgIndex);
          },
          nextTo: function nextTo() {
            return _this6.getNextItem(imgIndex);
          },
          info: { toolIconsFolder: _cloudfront("icons/gallery/tools/") }
        }
      };
    }
  }, {
    key: "getNextItem",
    value: function getNextItem(itemId) {
      var _this7 = this;

      var imgIndex = parseInt(itemId, 10) + 1;

      return imgIndex > this.props.totalImages - 1 ? null : {
        pathname: "/gallery/" + imgIndex,
        state: {
          modal: true,
          fullScreen: true,
          previousTo: function previousTo() {
            return _this7.getPreviousItem(imgIndex);
          },
          nextTo: function nextTo() {
            return _this7.getNextItem(imgIndex);
          },
          info: { toolIconsFolder: _cloudfront("icons/gallery/tools/") }
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var itemIndex = this.props.data.img.index;
      var divStyle = {
        width: this.props.data.imageWidth + "px",
        height: this.props.data.imageHeight + "px",
        transform: "translate(" + this.props.data.leftPos + "px , " + this.props.data.topPos + "px)",
        opacity: this.props.data.visibility
      };
      var loadingImgs = 0;
      // const windowWidth = window.screen.width;
      var windowWidth = window.innerWidth;
      // setTimeout(()=>
      // {
      //   if(this.refImage)
      //   {
      //     this.refImage.src = this.props.data.img.src;
      //   }
      // }, 50*(itemIndex + 1));
      return _react2.default.createElement(
        _reactRouter.Link,
        {
          key: "link" + itemIndex,
          className: linkWrap,
          to: {
            pathname: "/gallery/" + itemIndex,
            state: {
              modal: true,
              fullScreen: true,
              previousTo: function previousTo() {
                return _this8.getPreviousItem(itemIndex);
              },
              nextTo: function nextTo() {
                return _this8.getNextItem(itemIndex);
              },
              info: { toolIconsFolder: _cloudfront("icons/gallery/tools/") }
            }
          } },
        _react2.default.createElement(
          "div",
          { className: tileStyles, key: itemIndex, style: divStyle },
          _react2.default.createElement("img", {
            src: "data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
            ref: function ref(image) {
              _this8.refImage = image;
            }
          }),
          _react2.default.createElement(
            "div",
            { className: imageDescStyles(this.props.fontScale) },
            _react2.default.createElement(
              "div",
              null,
              this.props.data.img.title
            ),
            _react2.default.createElement(
              "div",
              null,
              this.props.data.img.author
            ),
            !!this.props.data.img.tools && this.props.data.img.tools.length > 0 && _react2.default.createElement(
              "ul",
              { className: toolsIcons },
              this.props.data.img.tools.map(function (tool) {
                return _react2.default.createElement(
                  "li",
                  { className: toolIcon, key: tool },
                  _react2.default.createElement(
                    "span",
                    toolName,
                    tool.replace("-", " ").replace("_", " ")
                  ),
                  _react2.default.createElement("img", { src: _cloudfront("icons/gallery/tools/") + tool.toLowerCase() + ".png" })
                );
              })
            )
          )
        )
      );
    }
  }]);
  return Tile;
}(_react2.default.Component);

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Eductional/Education.jsx
// module id = 2884
// module chunks = 0